var map = {
	"./bs_t-2_stitch_blk.png": 402483,
	"./bs_t-2_stitch_blu.png": 791757,
	"./bs_t-2_stitch_cml.png": 935842,
	"./bs_t-2_stitch_crk.png": 166264,
	"./bs_t-2_stitch_grn.png": 967545,
	"./bs_t-2_stitch_lgd.png": 681811,
	"./bs_t-2_stitch_lsl.png": 477111,
	"./bs_t-2_stitch_nvy.png": 871327,
	"./bs_t-2_stitch_orn.png": 128545,
	"./bs_t-2_stitch_pnk.png": 215275,
	"./bs_t-2_stitch_ppl.png": 985370,
	"./bs_t-2_stitch_red.png": 864791,
	"./bs_t-2_stitch_sax.png": 610562,
	"./bs_t-2_stitch_wht.png": 651709,
	"./bs_t-2_stitch_ylw.png": 840692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642533;